export type AutoCompleteProps = {
  itemIdKey: string;
  itemLabelKey: string;
  onToggleItem: (itemId: string) => void;
  onSelectItems: (newSelectedIds: string[]) => void;
  onClearItems: () => void;
  selectedIds: string[] | string;
  canSelectMultiple: boolean;
  items: (searchTerm: string) => unknown[];
  isLoading: (searchTerm: string) => boolean;
  canLoadMoreItems: (searchTerm: string) => boolean;
  loadMoreData: (searchTerm: string) => void;
};

export enum AutoCompleteFilter {
  MATCH_SUB_REQUEST_DROPDOWN = 'MATCH_SUB_REQUEST_DROPDOWN',
  MATCH_SUB_REQUEST_DROPDOWN_LEGACY = 'MATCH_SUB_REQUEST_DROPDOWN_LEGACY'
}
